@import "mixins";

:host {
  @include socialauthlinks__google-signin;

  width: 100%;
}
